import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(err, info) {
    // eslint-disable-next-line no-console
    if (process.env.NODE_ENV !== "production") console.error(err, info);
    // Placeholder: Sentry.captureException(err, { extra: info });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="min-h-screen flex items-center justify-center p-8 text-center"
          data-testid="app-error-boundary"
        >
          <div className="max-w-md">
            <h1 className="text-2xl font-semibold mb-3">Something went wrong.</h1>
            <p className="text-sm text-muted-foreground mb-6">
              An unexpected error occurred. Please reload the page to continue.
            </p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="px-4 py-2 rounded-md bg-primary text-primary-foreground hover:opacity-90"
              data-testid="error-boundary-reload-btn"
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
